import * as React from 'react'

import { PowerReview } from '@thg-commerce/enterprise-components'
import { PowerReviewComponentType } from '@thg-commerce/enterprise-components/src/PowerReview'
import { getProductFeed } from '@thg-commerce/enterprise-components/src/PowerReview/utils'
import { useSiteDefinition } from '@thg-commerce/enterprise-core'
import { mq, spacing, styled } from '@thg-commerce/enterprise-theme'

const PowerReviewDisplayContainer = styled.div`
  margin: ${spacing(5)} 0 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    margin: ${spacing(9)} 0 0;
  }
`

import { useProductPage } from '../../context'

export const PowerReviewDisplay = () => {
  const { product, selectedVariant } = useProductPage()
  const { defaultLocale } = useSiteDefinition()

  if (!product || !selectedVariant) {
    return null
  }

  return (
    <PowerReviewDisplayContainer>
      <PowerReview
        externalId={selectedVariant.externalIdentifier ?? ''}
        locale={defaultLocale}
        sku={selectedVariant.sku}
        component={PowerReviewComponentType.REVIEW_DISPLAY}
        id="pr-review-display"
        powerReviewGroups={product.powerReviewCategory}
        product={getProductFeed(
          selectedVariant,
          product,
          product.powerReviewCategory,
        )}
        mainProduct={true}
      />
    </PowerReviewDisplayContainer>
  )
}
